export const PERMISOS = {
  COMPRAS: {
    VER_GESTION: "COMPRAS.VER_DOCUMENTOS",
    VER_APROBACIONES: "COMPRAS.VER_APROBACIONES",
  },
  NEGOCIACIONES: {
    // 👉 Permisos generales de visualización
    VER_GRUPOS: "COMPRAS.VER_GRUPOS",
    VER_UNIFICADOS: "COMPRAS.VER_UNIFICADOS",
    VER_GRUPO_ESCALAS: "COMPRAS.VER_GRUPO_ESCALAS",
    VER_ESCALAS_EFECTIVAS: "COMPRAS.VER_ESCALAS_EFECTIVAS",
    VER_BONIFICACIONES: "COMPRAS.VER_BONIFICACIONES",
    VER_CRECIMIENTO: "COMPRAS.VER_CRECIMIENTO",

    // 👉 Permisos específicos para Grupos
    CREAR_GRUPO: "COMPRAS.CREAR_GRUPO",
    EDITAR_GRUPO: "COMPRAS.EDITAR_GRUPO",
    DUPLICAR_GRUPO: "COMPRAS.DUPLICAR_GRUPO",
    EDITAR_VIGENCIAS_GRUPO: "COMPRAS.EDITAR_VIGENCIAS_GRUPO",

    // 👉 Permisos específicos para Grupo Escalas
    GRUPO_ESCALAS_CREAR: "COMPRAS.CREAR_GRUPO_ESCALAS",
    GRUPO_ESCALAS_EDITAR: "COMPRAS.EDITAR_GRUPO_ESCALAS",
    GRUPO_ESCALAS_DUPLICAR: "COMPRAS.DUPLICAR_GRUPO_ESCALAS",
    GRUPO_ESCALAS_EDITAR_VIGENCIAS: "COMPRAS.EDITAR_VIGENCIAS_GRUPO_ESCALAS",

    // 👉 Permisos específicos para Escalas Efectivas
    ESCALAS_EFECTIVAS_CREAR: "COMPRAS.CREAR_ESCALAS_EFECTIVAS",
    ESCALAS_EFECTIVAS_EDITAR: "COMPRAS.EDITAR_ESCALAS_EFECTIVAS",
    ESCALAS_EFECTIVAS_DUPLICAR: "COMPRAS.DUPLICAR_ESCALAS_EFECTIVAS",
    ESCALAS_EFECTIVAS_EDITAR_VIGENCIAS:
      "COMPRAS.EDITAR_VIGENCIAS_ESCALAS_EFECTIVAS",

    // 👉 Permisos específicos para Bonificaciones
    BONIFICACIONES_CREAR: "COMPRAS.CREAR_BONIFICACIONES",
    BONIFICACIONES_EDITAR: "COMPRAS.EDITAR_BONIFICACIONES",
    BONIFICACIONES_DUPLICAR: "COMPRAS.DUPLICAR_BONIFICACIONES",
    BONIFICACIONES_EDITAR_VIGENCIAS: "COMPRAS.EDITAR_VIGENCIAS_BONIFICACIONES",

    // 👉 Permisos específicos para Crecimiento
    CRECIMIENTO_CREAR: "COMPRAS.CREAR_CRECIMIENTO",
    CRECIMIENTO_EDITAR: "COMPRAS.EDITAR_CRECIMIENTO",
    CRECIMIENTO_DUPLICAR: "COMPRAS.DUPLICAR_CRECIMIENTO",
    CRECIMIENTO_EDITAR_VIGENCIAS: "COMPRAS.EDITAR_VIGENCIAS_CRECIMIENTO",

    // 👉 Permisos específicos para Unificados
    UNIFICADOS_CREAR: "COMPRAS.CREAR_UNIFICADOS",
    UNIFICADOS_EDITAR: "COMPRAS.EDITAR_UNIFICADOS",
    UNIFICADOS_DUPLICAR: "COMPRAS.DUPLICAR_UNIFICADOS",
    UNIFICADOS_EDITAR_VIGENCIAS: "COMPRAS.EDITAR_VIGENCIAS_UNIFICADOS",

    // 👉 Permisos específicos para Exportar reporte
    ACUERDOS_EXPORTAR_REPORTE: "COMPRAS.EXPORTAR_REPORTE_ACUERDOS",
    CRECIMIENTO_EXPORTAR_REPORTE: "COMPRAS.EXPORTAR_REPORTE_CRECIMIENTO",
    EFECTIVIDAD_SUMINISTRO_EXPORTAR_REPORTE:
      "COMPRAS.EXPORTAR_REPORTE_EFECTIVIDAD_SUMINISTRO",
    BONIFICACIONES_EXPORTAR_REPORTE: "COMPRAS.EXPORTAR_REPORTE_BONIFICACIONES",
    ROTACION_INVENTARIO_EXPORTAR_REPORTE:
      "COMPRAS.EXPORTAR_REPORTE_ROTACION_INVENTARIO",
  },
  MAESTROS: {
    VER_TEMPLATE_RECIPIENTS: "COMPRAS.VER_TEMPLATE_RECIPIENTS",
    CREAR_TEMPLATE_RECIPIENT: "COMPRAS.CREAR_TEMPLATE_RECIPIENT",
    EDITAR_TEMPLATE_RECIPIENT: "COMPRAS.EDITAR_TEMPLATE_RECIPIENT",
    ELIMINAR_TEMPLATE_RECIPIENT: "COMPRAS.ELIMINAR_TEMPLATE_RECIPIENT",
  },
};
